import { LitElement, html, css, unsafeCSS, nothing } from 'lit';
import styles from './card-document.scss?inline';

export default class SotbitCardDocument extends LitElement {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    static properties = {
        documentHref: { type: String, attribute: 'document-href' },
        documentName: { type: String, attribute: 'document-name' },
        documentSize: { type: String, attribute: 'document-size' },
        documentIcon: { type: String, attribute: 'document-icon' },
        download: { type: Boolean },
        target: { type: String },
    };

    constructor() {
        super();

        this.documentHref = null;
        this.documentName = null;
        this.documentSize = null;
        this.documentIcon = 'docs';
        this.download = false;
        this.target = null;
    }

    render() {
        return html`
            <a class="card" href="${this.documentHref}" ?download="${this.download}" target="${this.target || nothing}">
                <div class="outline"></div>
                <sotbit-icon class="icon-left" icon="${this.documentIcon}" size="l" no-padding></sotbit-icon>
                <div class="card-body">
                    ${this.documentName
                        ? html`<div class="name">
                              <span>${this.documentName}</span>
                          </div>`
                        : ''}
                    ${this.documentName ? html`<div class="size">${this.documentSize}</div>` : ''}
                </div>

                ${this.documentHref
                    ? html` <div class="icon-right">
                          <sotbit-icon size="m" pointer variant="primary" icon="download"></sotbit-icon>
                      </div>`
                    : ''}
            </a>
        `;
    }
}
